import { LegalDocument } from "@/components/LegalDocument";
import { Seo } from "@/components/Seo";
import blocks from "@/legal/privacy.json";

const Privacy = () => (
  <>
    <Seo
      title="Privacy Policy — DELSHA"
      description="The official DELSHA Privacy Policy — how DELSHA collects, uses, stores and protects personal information."
    />
    <LegalDocument blocks={blocks} testId="privacy" />
  </>
);

export default Privacy;
